import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"

import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"

import logo from "../../assets/images/logo.png"
import { withTranslation } from "react-i18next"
import ConfigUrl from "config"
import secureLocalStorage from "react-secure-storage"
import Configs from "../../config"
import { FaInfo, FaInfoCircle } from "react-icons/fa"
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap"
import { MdFullscreen } from "react-icons/md"
import { FaGauge } from "react-icons/fa6"
import moment from "moment"

const getWeekDates = () => {
  const today = new Date()
  const day = today.getDay() // 0=Sun, 1=Mon, ..., 5=Fri, 6=Sat

  // Find the most recent Saturday (start of week)
  const daysFromSaturday = (day - 6 + 7) % 7
  const saturday = new Date(today)
  saturday.setDate(today.getDate() - daysFromSaturday)

  // Friday is always 6 days after Saturday (end of week)
  const friday = new Date(saturday)
  friday.setDate(saturday.getDate() + 6)

  const format = date =>
    date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })

  return {
    start: format(saturday),
    end: format(friday),
  }
}

const Header = props => {
  const navigate = useNavigate()

  const { start, end } = getWeekDates()

  const [isCollapsed, setIsCollapsed] = useState(false)
  const [infoModal, setInfoModal] = useState(false)

  function tToggle() {
    var body = document.body
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable")
      setIsCollapsed(prev => !prev)
    } else {
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
      setIsCollapsed(prev => !prev)
    }
  }

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  const PLWEEK = JSON.parse(secureLocalStorage?.getItem("PLWEEK"))
  const KPIWEEK = JSON.parse(secureLocalStorage?.getItem("KPIWEEK"))
  const FINALRANGE = secureLocalStorage?.getItem("FINALRANGE")

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <button
              type="button"
              onClick={() => {
                tToggle()
              }}
              className="btn btn-sm pe-4 font-size-16 text-white header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>

            {!isCollapsed && (
              <div className="d-flex">
                <div className="navbar-brand-box ">
                  <Link to={`${Configs.appurl}`} className="logo">
                    <span>
                      <img
                        src={logo}
                        alt="JobFitMeter logo"
                        className="job-logo object-fit-cover rounded-2 bg-white"
                        height="40"
                      />
                    </span>
                  </Link>
                </div>
              </div>
            )}
          </div>
          <div className="d-flex">
            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                className="btn header-item noti-icon "
                onClick={() => {
                  toggleFullscreen()
                }}
                data-toggle="fullscreen"
              >
                <MdFullscreen size={20} color="white" />
              </button>
            </div>
            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                className="btn header-item noti-icon "
                onClick={() => {
                  navigate(`${Configs.appurl}guage-range`)
                }}
                data-toggle="fullscreen"
              >
                <FaGauge size={16} color="white" />
              </button>
            </div>
            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                className="btn header-item noti-icon "
                onClick={() => {
                  setInfoModal(true)
                }}
                data-toggle="fullscreen"
              >
                <FaInfoCircle size={18} color="white" />
              </button>
            </div>
            <ProfileMenu />
            <NotificationDropdown />
          </div>
        </div>
      </header>

      <Modal isOpen={infoModal} toggle={() => setInfoModal(false)} centered>
        <ModalHeader toggle={() => setInfoModal(false)}>
          Week Ending Info
        </ModalHeader>
        <ModalBody>
          <p className="text-muted mb-3" style={{ fontSize: "13px" }}>
            The working week runs from{" "}
            <strong className="text-black">Saturday</strong> to{" "}
            <strong className="text-black">Friday</strong>.
          </p>

          <div className="d-flex flex-column gap-2">
            <div
              style={{
                background: "#f8faff",
                border: "1px solid #ede9fe",
                borderRadius: "10px",
                padding: "12px 16px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span
                style={{ fontSize: "13px", color: "#64748b", fontWeight: 600 }}
              >
                📅 Current Week Start (Saturday)
              </span>
              <strong style={{ color: "#6C63FF", fontSize: "13px" }}>
                {start
                  ? new Date(start).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })
                  : "—"}
              </strong>
            </div>

            <div
              style={{
                background: "#f8faff",
                border: "1px solid #ede9fe",
                borderRadius: "10px",
                padding: "12px 16px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span
                style={{ fontSize: "13px", color: "#64748b", fontWeight: 600 }}
              >
                📅 Current Week End (Friday)
              </span>
              <strong style={{ color: "#EF5350", fontSize: "13px" }}>
                {end
                  ? new Date(end).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })
                  : "—"}
              </strong>
            </div>
          </div>

          <div className="mt-3">
            <h6
              className="mb-2"
              style={{
                background: "#fefce8",
                border: "1px solid #ede9fe",
                borderRadius: "10px",
                padding: "12px 16px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                color: "#92400e",
              }}
            >
              KPI Sheet Latest Week:{" "}
              <span className=" fw-bold">
                {moment(KPIWEEK?.[1])?.format("DD/MM/YYYY") ?? "—"} -{" "}
                {moment(KPIWEEK?.[0])?.format("DD/MM/YYYY") ?? "—"}
              </span>
            </h6>
            <h6
              className="mb-2"
              style={{
                background: "#f0fdf4",
                border: "1px solid #ede9fe",
                borderRadius: "10px",
                padding: "12px 16px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                color: "#15803d",
              }}
            >
              P&L Sheet Latest Week:{" "}
              <span className=" fw-bold text-end">
                {moment(PLWEEK?.[1])?.format("DD/MM/YYYY") ?? "—"} -{" "}
                {moment(PLWEEK?.[0])?.format("DD/MM/YYYY") ?? "—"}
              </span>
            </h6>
            <h6
              className="mb-0"
              style={{
                background: "#fff",
                border: "1px solid #ede9fe",
                borderRadius: "10px",
                padding: "12px 16px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                color: "#222",
              }}
            >
              Showing Data:{" "}
              <span className=" fw-bold text-end">
                {FINALRANGE?.[0] ? moment(FINALRANGE[0]).format("DD/MM/YYYY") : "—"} -{" "}
                {FINALRANGE?.[1] ? moment(FINALRANGE[1]).format("DD/MM/YYYY") : "—"}
              </span>
            </h6>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

export default withTranslation()(Header)
